import React from 'react'
import ProdIOTRetOPRow from './ProdIOTRetOPRow'
import FormLabel from '../../../../../library/form/components/FormLabel';
import withView from '../../../../cmn/docAutomation/withView';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import FormSearchButton from '../../../../../library/form/components/FormSearchButton';
import SarasTrans from '../../../../../library/notifications/SarasTrans';
import FormWrapper from "../../../../../library/form/components/FormWrapper";
import { UiView, UiViewHeading, UiAction, UiViewContent } from "../../../../../library/layout/Index";
import useRowSelector from "../../../../../library/hooks/selector/useRowSelector";
import * as fn from "../../../../../helper/uiFunctions";

const ProdIOTRetOP = (props) => {
    const { formObject, viewData } = props;

    const rowSelector = useRowSelector("2", null);
    
    const renderItemToReturn = (row, index) => {
        if (fn.compareNumber(row.rowValues.isAlreadyRet.val, 0)) {
            return (
                <li><ProdIOTRetOPRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} rowSelector={rowSelector} index={index + 1} /></li>
            )
        }
        else {
            return (null);
        }
    }

    return (
        <>
            <UiView>
                <UiViewHeading>
                    <UiAction>
                        <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                            tooltip="Add Semi Finished Output"
                            text={<SarasTrans value="Add SFO" />}
                            action={{ actionId: "refresh", refreshMode: "dep",
                            actionParam: { actionType: "addSFO", pathKey: "TRET", viewKey: "optReturn" }
                            }} />

                        <span class="uiSpacerH10">Add Non Issue Return</span>
                        <FormSearchButton formObject={formObject} rowKey="" headerKey='lineItemLink'
                            tooltip="Add Non Issue Return"
                            action={{ actionId: "new", actionParam: { actionType: "addNIR", actionKey: "NIR", pathKey: "TRET", viewKey: "optReturn" } }}
                            className='uiActionButton uiSpacerH10' placeholder="Barcode or Item Id"
                        />
                    </UiAction>
                </UiViewHeading>
                <UiViewContent>
                    <ul className="uiListTable" style={{ marginBotton: "20px" }}>
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumnCenter uiColumn50"><SarasTrans value="Sr No." /></li>
                                <li className="uiColumnCenter uiColumn70"><SarasTrans value="Item Id" /></li>
                                <li className="uiColumnCenter uiColumn200"><SarasTrans value="Item Name" /></li>
                                <li className="uiColumnCenter uiColumn100"><SarasTrans value="Unit" /></li>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                                    action={{ paramName: "variation1Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation1Name" }} value="Variation 1" />
                                </FormWrapper>
                                <FormWrapper customWrapper="li" formObject={formObject} wrapperClass="uiColumnCenter uiColumn100" headerKey="viewConfig"
                                    action={{ paramName: "variation2Name" }} >
                                    <FormLabel formObject={formObject} headerKey="viewConfig" action={{ paramName: "variation2Name" }} value="Variation 2" />
                                </FormWrapper>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Qty Return" /></li>
                                <li className="uiColumnCenter uiColumn150"><SarasTrans value="Remark" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData ? viewData : {}).map((row, index) => (
                                renderItemToReturn(row, index)
                            ))
                        }
                    </ul>
                </UiViewContent>
            </UiView>
        </>
    )
}

export default withView(ProdIOTRetOP, "prodIOTRetOP", "");
